import { Component, OnInit,ViewChild, ChangeDetectionStrategy, NgZone, ApplicationRef, Input } from '@angular/core';
import { LoadingBarService } from '@ngx-loading-bar/core';

import { EmbryoService } from '../../Services/Embryo.service';
import { Observable, BehaviorSubject } from 'rxjs';
import { fbShippingMetric } from 'src/app/Models/fbUser';
import { first } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'embryo-PaymentDetailSideBar',
  templateUrl: './PaymentDetailSideBar.component.html',
  styleUrls: ['./PaymentDetailSideBar.component.scss'],
  changeDetection:ChangeDetectionStrategy.OnPush
})
export class PaymentDetailSideBarComponent implements OnInit {

   cartProducts  : any;
   popupResponse : any;

   @Input() currency:string;
   @Input() exchangeMX:number;

   totalPrice$:BehaviorSubject<number> = new BehaviorSubject<number>(0);


   constructor(public embryoService: EmbryoService,
               private loadingBar: LoadingBarService,
               private ngZone:NgZone,
               private appRef:ApplicationRef,
               public translate:TranslateService) { }

   ngOnInit() {
      
   }

   public calculateTotalPrice() {
      let subtotal = 0;
      if(this.embryoService.localStorageCartProductsBehaviour.value && this.embryoService.localStorageCartProductsBehaviour.value.length>0) {
         for(let product of this.embryoService.localStorageCartProductsBehaviour.value) {
            subtotal += (product.discount_price *product.quantity) ;
         }
      }
      return subtotal;
   }

   public removeProduct(value) {
      let message = "Are you sure you want to delete this product?";
      this.embryoService.confirmationPopup(message).
         subscribe(res => {this.popupResponse = res},
                   err => console.log(err),
                   ()  => this.getPopupResponse(this.popupResponse, value)
                  );
   }

   public getPopupResponse(response, value) {
      if(response){
         this.embryoService.removeLocalCartProduct(value);
         this.embryoService.paymentSidenavOpen = false;
      }
   }

   public calculateProductSinglePrice(product:any, value: any) {
      let price = 0;
      product.quantity = value;
      price = product.discount_price*value;
      return price;
   }
   public getTotalPrice(): BehaviorSubject<number> {
      return this.embryoService.getTotalPrice();

   }


}
